import styled, { css } from 'styled-components';

import { BadgeColor } from 'types';

export const Container = styled.span`
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`;

export const Text = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// "<name> · <word>" in the cart chip: the name gives way, the word stays.
export const Labelled = styled.span`
  min-width: 0;
  display: inline-flex;
`;

export const Word = styled.span`
  flex-shrink: 0;
`;

// The word beside the dot in the cart picker: small, grey, never wraps.
export const Note = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

// Same size and tokens as the badge dot (components/badge Dot).
export const Dot = styled.i<{ $color: BadgeColor }>`
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 50%;

  ${({ theme, $color }) => {
    const config = theme.config.badge[$color];
    return (
      'dot' in config &&
      css`
        background-color: ${config.dot};
      `
    );
  }}
`;
